import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, TermSheet } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useGetTermSheetQuery(
	dealGuid?: Guid | undefined,
	termSheetGuid?: Guid | null | undefined,
	options?: Omit<UseQueryOptions<TermSheet, unknown, TermSheet, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.TermSheets.Specific(dealGuid, termSheetGuid),
		() =>
			AxiosUtils.getResponseData<TermSheet>(
				api.get(CerebroApiEndpoints.TermSheets.Specific(dealGuid, termSheetGuid))
			),
		options
	);
}
